import { createFeature, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { Planning } from './planning.model';
import { PlanningActions } from './planning.actions';

export const planningsFeatureKey = 'plannings';

export type State = EntityState<Planning>

export const adapter: EntityAdapter<Planning> = createEntityAdapter<Planning>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(PlanningActions.addPlanning,
    (state, action) => adapter.addOne(action.planning, state)
  ),
  on(PlanningActions.upsertPlanning,
    (state, action) => adapter.upsertOne(action.planning, state)
  ),
  on(PlanningActions.addPlannings,
    (state, action) => adapter.addMany(action.plannings, state)
  ),
  on(PlanningActions.upsertPlannings,
    (state, action) => adapter.upsertMany(action.plannings, state)
  ),
  on(PlanningActions.updatePlanning,
    (state, action) => adapter.updateOne(action.planning, state)
  ),
  on(PlanningActions.updatePlannings,
    (state, action) => adapter.updateMany(action.plannings, state)
  ),
  on(PlanningActions.deletePlanning,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(PlanningActions.deletePlannings,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(PlanningActions.loadPlannings,
    (state, action) => adapter.setAll(action.plannings, state)
  ),
  on(PlanningActions.clearPlannings,
    state => adapter.removeAll(state)
  )
);

export const planningsFeature = createFeature({
  name: planningsFeatureKey,
  reducer,
  extraSelectors: ({ selectPlanningsState }) => ({
    ...adapter.getSelectors(selectPlanningsState)
  })
});

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal
} = planningsFeature;
